import { HStack, MenuRoot, MenuTrigger } from '@chakra-ui/react';

import { Button, Typography, MenuContent, Show } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { CoachingMode } from 'features/participants/config/types';
import { SessionsTableMoreOptionsCancelMenuItem } from 'features/sessions/components/Table/MoreOptions/CancelSessionMenuItem';
import { SessionsTableMoreOptionsRescheduleMenuItem } from 'features/sessions/components/Table/MoreOptions/RescheduleSessionMenuItem';
import { SessionsTableMoreOptionsViewSessionMenuItem } from 'features/sessions/components/Table/MoreOptions/ViewSessionMenuItem';
import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';
import { useParticipantsTableCancelMutateOptions } from 'features/sessions/hooks/useParticipantsTableCancelMutateOptions';
import { useParticipantsTableRescheduleMutateOptions } from 'features/sessions/hooks/useParticipantsTableRescheduleMutateOptions';

type ParticipantsSessionDateTimeMenuProps = {
  userEmail: string;
  startAt: string;
  sessionId: string;
  attendance: SessionAttendanceStatusType;
  coachingMode: CoachingMode;
};

export const ParticipantsSessionDateTimeMenu = ({
  userEmail,
  startAt,
  sessionId,
  attendance,
  coachingMode,
}: ParticipantsSessionDateTimeMenuProps) => {
  const cancelMutateOptions =
    useParticipantsTableCancelMutateOptions(sessionId);
  const rescheduleMutateOptions =
    useParticipantsTableRescheduleMutateOptions(sessionId);

  return (
    <MenuRoot>
      <MenuTrigger as={Button} variant="ghost">
        <HStack gap={0}>
          <Typography
            fontSize="small"
            fontWeight="medium"
            data-testid="participants-list-scheduled-next-session-date"
          >
            {dateUtils.localDate(startAt).format('MMM D, h:mm A')}
          </Typography>
          <Icon name={iconNames.dotsVert} />
        </HStack>
      </MenuTrigger>
      <MenuContent w="140px">
        <SessionsTableMoreOptionsViewSessionMenuItem
          userEmail={userEmail}
          sessionId={sessionId}
        />
        <Show
          when={
            attendance === SESSION_ATTENDANCE_STATUS.ATTENDED ||
            attendance === SESSION_ATTENDANCE_STATUS.RESCHEDULED ||
            attendance === SESSION_ATTENDANCE_STATUS.SCHEDULED
          }
        >
          <SessionsTableMoreOptionsRescheduleMenuItem
            sessionId={sessionId}
            sessionStartAt={startAt}
            options={rescheduleMutateOptions}
            coachingMode={coachingMode}
          />
          <SessionsTableMoreOptionsCancelMenuItem
            sessionId={sessionId}
            options={cancelMutateOptions}
          />
        </Show>
      </MenuContent>
    </MenuRoot>
  );
};
